import { Link } from "react-router-dom";
import { LogOut, ExternalLink } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useAuth } from "@/context/AuthContext";
import { Seo } from "@/components/site/Seo";
import { RequestsList } from "@/components/admin/RequestsList";
import { PortfolioManager } from "@/components/admin/PortfolioManager";
import { AccountSettings } from "@/components/admin/AccountSettings";
import { AdminOrders } from "@/components/admin/AdminOrders";
import { AdminTopups } from "@/components/admin/AdminTopups";
import { AdminCustomers } from "@/components/admin/AdminCustomers";
import { AdminPricing, AdminTransactions } from "@/components/admin/AdminPricing";
import { AdminSupport } from "@/components/admin/OrderMedia";
import { LogoMark } from "@/components/site/Logo";

export default function AdminDashboard() {
  const { user, logout } = useAuth();
  return (
    <div className="min-h-screen bg-[var(--km-bg)]" data-testid="admin-dashboard">
      <Seo title="لوحة التحكم" noindex />
      <header className="km-glass sticky top-0 z-40 border-b border-purple-500/20">
        <div className="mx-auto flex max-w-6xl items-center justify-between gap-3 px-4 py-3">
          <div className="flex items-center gap-3">
            <span className="rounded-xl bg-white px-2 py-1"><LogoMark className="h-8" /></span>
            <div>
            <p className="font-display text-2xl text-white">لوحة التحكم</p>
            <p className="text-xs text-purple-300/70" dir="ltr" style={{ textAlign: "right" }}>{user?.email}</p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <Link to="/" target="_blank" className="hidden items-center gap-1 rounded-full border border-purple-500/30 px-4 py-2 text-sm text-[var(--km-lilac)] hover:text-white sm:flex" data-testid="admin-view-site-link">
              <ExternalLink className="h-4 w-4" /> الموقع
            </Link>
            <button onClick={logout} className="flex items-center gap-1 rounded-full bg-white/10 px-4 py-2 text-sm text-white hover:bg-red-500" data-testid="admin-logout-btn">
              <LogOut className="h-4 w-4" /> خروج
            </button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-6xl px-4 py-8">
        <Tabs defaultValue="orders" dir="rtl">
          <TabsList className="mb-6 h-auto flex-wrap rounded-full bg-[var(--km-card)] p-1">
            <TabsTrigger value="orders" className="font-head rounded-full px-6 py-2 data-[state=active]:bg-[var(--km-pink)] data-[state=active]:text-white" data-testid="admin-tab-orders">الأوردرات</TabsTrigger>
            <TabsTrigger value="topups" className="font-head rounded-full px-6 py-2 data-[state=active]:bg-[var(--km-pink)] data-[state=active]:text-white" data-testid="admin-tab-topups">شحن المحافظ</TabsTrigger>
            <TabsTrigger value="customers" className="font-head rounded-full px-6 py-2 data-[state=active]:bg-[var(--km-pink)] data-[state=active]:text-white" data-testid="admin-tab-customers">العملاء</TabsTrigger>
            <TabsTrigger value="transactions" className="font-head rounded-full px-6 py-2 data-[state=active]:bg-[var(--km-pink)] data-[state=active]:text-white" data-testid="admin-tab-transactions">المعاملات</TabsTrigger>
            <TabsTrigger value="pricing" className="font-head rounded-full px-6 py-2 data-[state=active]:bg-[var(--km-pink)] data-[state=active]:text-white" data-testid="admin-tab-pricing">الأسعار</TabsTrigger>
            <TabsTrigger value="requests" className="font-head rounded-full px-6 py-2 data-[state=active]:bg-[var(--km-pink)] data-[state=active]:text-white" data-testid="admin-tab-requests">طلبات قديمة</TabsTrigger>
            <TabsTrigger value="portfolio" className="font-head rounded-full px-6 py-2 data-[state=active]:bg-[var(--km-pink)] data-[state=active]:text-white" data-testid="admin-tab-portfolio">البورتفوليو</TabsTrigger>
            <TabsTrigger value="account" className="font-head rounded-full px-6 py-2 data-[state=active]:bg-[var(--km-pink)] data-[state=active]:text-white" data-testid="admin-tab-account">الحساب</TabsTrigger>
          </TabsList>
          <TabsContent value="orders"><AdminOrders /></TabsContent>
          <TabsContent value="topups"><AdminTopups /></TabsContent>
          <TabsContent value="customers"><AdminCustomers /></TabsContent>
          <TabsContent value="transactions"><AdminTransactions /></TabsContent>
          <TabsContent value="pricing"><AdminPricing /><AdminSupport /></TabsContent>
          <TabsContent value="requests"><RequestsList /></TabsContent>
          <TabsContent value="portfolio"><PortfolioManager /></TabsContent>
          <TabsContent value="account"><AccountSettings /></TabsContent>
        </Tabs>
      </main>
    </div>
  );
}
